<template>
  <div id="q-app">
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      appear
      :duration="300"
    >
      <q-layout v-if="isBooting">
        <q-page-container>
          <q-page class="flex flex-center column">
            <q-spinner-puff
              color="primary"
              size="2em"
            />
          </q-page>
        </q-page-container>
      </q-layout>

      <router-view v-else />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState('application', ['language', 'isBooting']),
    ...mapState('vehicle', ['type']),
  },
  watch: {
    language() {
      this.$root.$i18n.locale = this.language;
    },
    // eslint-disable-next-line func-names
    '$route.query.language': function (language) {
      if (language === 'is' || language === 'en') {
        this.setLanguage(language);
      }
    },
  },
  async mounted() {
    try {
      await this.getProducts();

      if (!this.type) {
        // eslint-disable-next-line no-unused-vars
        this.$router.replace({ name: 'HomeScreen' }).catch((e) => {});
      }
    }
    catch (e) {
      // console.log(e);
    }
    finally {
      this.bootComplete();
    }
  },
  methods: {
    ...mapMutations('application', [
      'bootComplete', 'setLanguage',
    ]),
    ...mapActions('product', [
      'getProducts',
    ]),
  },
};
</script>
